import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { filter, interval, map, Subject, take, takeUntil, tap } from 'rxjs';
import { WINDOW } from 'app/core/core.module';

@Component({
  selector: 'tm-sign-up',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignUpComponent {
  readonly destroy$ = new Subject<void>();
  private readonly window = inject(WINDOW);
  private readonly authService = inject(AuthService);
  readonly GTMloaded$ = interval(200).pipe(
    takeUntil(this.destroy$),
    take(25),
    map(() => !!this.window['dataLayer']),
    filter((loaded) => loaded === true),
    // switchMap(() => {
    //   this.destroy$.next();
    //   return this.authService.loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } });
    // }),
    tap({
      next: () => this.destroy$.next(),
      complete: () => this.authService.loginWithRedirect({ authorizationParams: { screen_hint: 'signup' } })
    }),
  );
}